import { Component, inject } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { TranslationService } from '../../../translate.service';
import { ClevertapService } from '../../../service/clevertap.service';
import { LeadService } from '../../../service/lead.service';

@Component({
  selector: 'app-mobile-banner-asahi',
  imports: [RouterModule],
  templateUrl: './mobile-banner-asahi.component.html',
  styleUrl: './mobile-banner-asahi.component.scss'
})
export class MobileBannerAsahiComponent {
  private userId: string | null = null;
  private currentLang!: string;
  private currentQueryParams: any = {};
  source: any;
  private clevertapService = inject(ClevertapService);
  isImageLoaded = false;
  isImageLoading = true;
  leadService = inject(LeadService);
  userDetails: any;
  userMobileNo: any;
  constructor(
    private _actRoute: ActivatedRoute,
    private _translationService: TranslationService,
    private translateService: TranslateService,
    private router: Router,
    private route: ActivatedRoute
  ) { }

  ngOnInit() {
    this.route.queryParamMap.subscribe(params => {
      this.source = params.get('traffic_source');
    });
    this._actRoute.queryParams.subscribe((queryParams) => {
      const userId = queryParams["userId"];
      console.log("user id", userId);

      if (userId) {
        this.fetchUserDetails(userId, true);
      } else {
        this.clevertapService.clearStorage();
        this.clevertapService.trackEvent("visited_product_landing_page", {
          product_type: "income_protection",
          traffic_source: this.source,
        });
      }
    });
    this.currentLang = this.router.url.split('/')[1];
    this._actRoute.queryParams.subscribe((queryParams) => {
      if (queryParams['id']) {
        this.userId = queryParams['id'];
      }
      this.currentQueryParams = { ...queryParams };
    });
  }


  onExploreNow() {
    this.clevertapService.trackEvent('clicked_landing_page', {
      default: 'default'
    });
    const basePath = [this.router.url.split('/')[2]];
    if (this.userId) {
      this.router.navigate([this.currentLang, ...basePath, 'mobile', this.userId], {
        queryParams: this.currentQueryParams
      });
    } else {
      this.router.navigate([this.currentLang, ...basePath, 'mobile'], {
        queryParams: this.currentQueryParams
      });
    }
  }

  /** To fetch user details */
  private fetchUserDetails(userId: string, triggerCleverTap?: boolean) {
    this.leadService.getUserDetails(userId).subscribe({
      next: (response: any) => {
        if (response.success) {
          this.userDetails = response.data;
          console.log("user details", this.userDetails);

          if (triggerCleverTap) {
            const user = this.userDetails;
            const name = user.name || "";
            const firstName = name.split(" ")[0] || "";
            const lastName = name.split(" ").slice(1).join(" ") || "";
            const email = user.email || "";
            const phoneNumber = user.mobileNo || "";
            const countryCode = user.countryCode || '84';
            const customerId = `${countryCode}-${phoneNumber}`;
            const uuid = user.uuid || '';
            this.clevertapService
              .setUserProfile(email, firstName, lastName, phoneNumber, name, uuid);
            this.clevertapService.trackEvent("visited_product_landing_page",
              {
                product_type: "income_protection",
                traffic_source: this.source,
                mobileNo: phoneNumber,
                countryCode,
                customer_id: customerId,
                first_name: firstName,
                last_name: lastName,
                email
              });
          }
        }
      },
      error: (error) => {
        console.log(error);

      },
    });
  }
  private preloadBannerImage() {
    const webpImg = new Image();
    webpImg.onload = () => {
      this.isImageLoaded = true;
      this.isImageLoading = false;
    };
    webpImg.onerror = () => {
      const jpgImg = new Image();
      jpgImg.onload = () => {
        this.isImageLoaded = true;
        this.isImageLoading = false;
      };
      jpgImg.onerror = () => {
        this.isImageLoading = false;
      };
      jpgImg.src = '/png/banner.jpg';
    };
    webpImg.src = '/png/banner.webp';
  }
  private getTrafficSource(): string {
    const userAgent = navigator.userAgent || '';
    if (window.webkit?.messageHandlers?.closeHandler) {
      return 'ios_app';
    }
    if (window.AndroidInterface?.closeWebView) {
      return 'android_app';
    }
    const referrer = document.referrer;
    if (referrer) {
      if (referrer.includes('google')) {
        return 'google';
      } else if (referrer.includes('facebook')) {
        return 'facebook';
      } else if (referrer.includes('instagram')) {
        return 'instagram';
      } else if (referrer.includes('twitter') || referrer.includes('t.co')) {
        return 'twitter';
      } else if (referrer.includes('linkedin')) {
        return 'linkedin';
      } else if (referrer.includes('youtube')) {
        return 'youtube';
      } else {
        return 'web_referral';
      }
    }
    const urlParams = new URLSearchParams(window.location.search);
    const utmSource = urlParams.get('utm_source');
    if (utmSource) {
      return utmSource;
    }
    return 'direct';
  }
}